export default {
  bg: `contentBg`,
  borderRadius: `5px`,
  transition: `
    transform 250ms ease,
    box-shadow 250ms ease,
    color 250ms ease
  `,
  boxShadow: `1px 1px 3px 0 rgba(1,1,1,.03)`,
}
